/* eslint-disable camelcase */
import React from 'react';
import { useMediaQuery } from '../../../../../../../../util/useMediaQuery';

import { MegaMenuColumns, MegaMenuBorderRight, NavTitle, MegaMenuDropdown } from '../MegaMenuStyles';
import { DropdownButton, DropdownNavLink } from '../../PrimaryNavLinksStyles';

import { LargeIconLinks, ListLinks, ArticleLinks } from '../atoms/index';
import dropdown from '../../../../../assets/images/dropdown.svg';
import StyledMegamenuClose from '../atoms/MegamenuClose';

const CommunityMegaMenu = (
  item,
  navigation,
  currentPath,
  openCurrentMegaMenu,
  closeMegaMenu,
  isMegaMenuOpen,
  currentMegaMenu,
) => {
  const { primary_navigation_text } = item;
  const {
    community_mega_menu_community_title,
    community_mega_menu_community,
    community_mega_menu_get_involved_title,
    community_mega_menu_get_involved,
    community_mega_menu_featured_title,
    community_mega_menu_featured_articles,
  } = navigation;

  const isMobile = useMediaQuery('(max-width: 1023px)');

  return (
    <>
      <DropdownButton
        onClick={() => {
          if (isMegaMenuOpen && currentMegaMenu === 'community') closeMegaMenu();
          openCurrentMegaMenu('community');
        }}
        key={primary_navigation_text}
        className="nav-item"
        key={primary_navigation_text}
      >
        <DropdownNavLink
          role="button"
          tabIndex="0"
          aria-pressed="false"
          className={`${currentPath === 'community' && 'active'}`}
        >
          {primary_navigation_text}
        </DropdownNavLink>
        {!isMobile && <img className="dropdown" src={dropdown} />}
      </DropdownButton>

      {!isMobile && isMegaMenuOpen && currentMegaMenu === 'community' && (
        <MegaMenuDropdown id="communityMegaDropdown">
          <MegaMenuColumns>
            <MegaMenuBorderRight size={4}>
              <NavTitle className="community-title is-6 is-mega-menu-title">
                {community_mega_menu_community_title}
              </NavTitle>
              {LargeIconLinks(community_mega_menu_community)}
            </MegaMenuBorderRight>
            <div className="get-involved">
              <NavTitle className="community-get-involved-title is-6 is-mega-menu-title">
                {community_mega_menu_get_involved_title}
              </NavTitle>
              {ListLinks(community_mega_menu_get_involved)}
            </div>
            <div className="community-featured">
              <NavTitle className="community-featured-title is-6 is-mega-menu-title">
                {community_mega_menu_featured_title}
              </NavTitle>
              {ArticleLinks(community_mega_menu_featured_articles)}
            </div>
          </MegaMenuColumns>
        </MegaMenuDropdown>
      )}

      {isMobile && (
        <MegaMenuDropdown id="communityMegaDropdown">
          <MegaMenuColumns>
            <MegaMenuBorderRight size={4}>
              <NavTitle className="community-title is-6 is-mega-menu-title">
                {community_mega_menu_community_title}
              </NavTitle>
              {LargeIconLinks(community_mega_menu_community)}
            </MegaMenuBorderRight>
            <div className="get-involved">
              <NavTitle className="community-get-involved-title is-6 is-mega-menu-title">
                {community_mega_menu_get_involved_title}
              </NavTitle>
              {ListLinks(community_mega_menu_get_involved)}
            </div>
            <div>
              <NavTitle className="community-featured-title is-6 is-mega-menu-title">
                {community_mega_menu_featured_title}
              </NavTitle>
              {ArticleLinks(community_mega_menu_featured_articles)}
            </div>
          </MegaMenuColumns>
        </MegaMenuDropdown>
      )}

      {isMegaMenuOpen && !isMobile && <StyledMegamenuClose onClick={closeMegaMenu} />}
    </>
  );
};

export default CommunityMegaMenu;
